<template>
  <v-data-table
        :headers="headers"
        :items="tableData"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalCount"
    >
      <template #[`item.quantity`]="{item}">
        {{ item.lines.reduce((total, l) => l.quantity ? total + l.quantity : total, 0) }}
      </template>
      <template #[`item.received`]="{item}">
        {{ item.lines.reduce((total, l) => l.received ? total + l.received : total, 0) }}
      </template>
      <template #[`item.total`]="{item}">
        {{ item.lines.reduce((total, l) => total + (l.cost * l.quantity), 0) | currency(item.currency) }}
      </template>
      <template #[`item.action`]="{item}">
          <v-btn small outlined @click="open(item.id)">
              <v-icon left>mdi-eye</v-icon>
              View
          </v-btn>
          <v-btn class="ml-4" color="error" outlined small @click="deleteItem(item.id)" v-if="['draft','cancelled', 'imported'].includes(item.poStatus)" :loading="deleteLoading[item.id]">
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
      </template>
    </v-data-table>
</template>

<script>
import _ from "lodash";
import {mapActions} from 'vuex';
export default {
    props:{
        defaultFilter: {
          type: Object,
          default:() => ({})
        },
        headers:{
          type:Array,
          required:true
        }
    },
    data: () => ({
        tableData:[],
        loading:false,
        options: { itemsPerPage: 15, sortBy: ["orderDate"], sortDesc: [true] },
        totalCount:null,
        deleteLoading:[],
        search:{}
    }),
    mounted: function() {
    this.getPOs();
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getPOs();
      }, 100)
    },
    defaultFilter:{
      deep:true,
      handler: _.debounce(function() {
        this.getPOs();
      }, 400)
    }
  },
  methods: {
    ...mapActions("purchaseOrders",{getPurchaseOrders:"list", deletePo:'delete'}),
    getPOs() {
      this.loading = true;

      this.getPurchaseOrders({
          pagination: this.options,
          filter: this.defaultFilter
        })
        .then(data => {
          this.tableData = data.data;
          this.totalCount = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteItem(poId){
      this.$set(this.deleteLoading, poId, true)
      this.deletePo(poId).then(()=>{
        this.flashMessage.success({
          message: "Delete PO Successfully",
        });
        this.getPOs();
      }).catch(({data})=>{
        this.flashMessage.error({
          message: data.message
        });
        this.$set(this.deleteLoading, poId, false)
      })
    },
    
    open(id) {
      this.$router.push("/purchase-order/view/" + id);
    }
  }
    
}
</script>

<style>

</style>